/**
 * Builds the deep-link redirection URL from the `?path=...` search params
 * (e.g. `?path=prequalification&id=123` → `/prequalification?id=123`).
 * Underscores in the path segment become slashes (`pet_care` → `/pet/care`).
 * Params appearing before `path` are ignored (they belong to the entry URL,
 * e.g. utm tags); params after it are carried over as the query string.
 *
 * @param {Record<string, string>} paramsObject URL search param entries.
 * @return {string} The app-internal path to redirect to, or "" if no `path`.
 */
export const constructUrlPath = (paramsObject: {}): string => {
  if (!paramsObject || typeof paramsObject !== "object") return "";

  let basePath = "";
  let queryString = "";
  let pathSeen = false;

  Object.entries(paramsObject).forEach(([key, value]) => {
    if (key === "path") {
      const correctedPath = String(value).split("_").join("/");

      // Collapse leading slashes so a crafted path can't become a
      // protocol-relative URL (`path=_evil.com` → `//evil.com`).
      basePath = `/${correctedPath.replace(/^\/+/, "")}`;
      pathSeen = true;
    } else if (pathSeen) {
      // Values come from the untrusted entry URL — re-encode them.
      const pair = `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;

      queryString += queryString ? `&${pair}` : `?${pair}`;
    }
  });

  return basePath + queryString;
};
